import React from 'react';
import { Route, Switch } from 'wouter';
import { Container, Row, Col, Card } from 'react-bootstrap';
import StudentAttendanceReport from './components/reports/StudentAttendanceReport';
import ClassAttendanceReport from './components/reports/ClassAttendanceReport';
import StudentSelector from './components/reports/StudentSelector';
import ClassSelector from './components/reports/ClassSelector';
import DuplicateStudentsCard from './components/reports/DuplicateStudentsCard';
import StudentSyncButton from './components/reports/StudentSyncButton';
import Header from './components/checkin/Header';

import './styles/darkTheme.css';

function Reports() {
  return (
    <div style={{overflowX: 'hidden'}}>
      <Header title={'Reports'} />
      {/* Route Content */}
      <Switch>
        <Route path="/attendance/student/:studentId">
          {(params) => <StudentAttendanceReport studentId={params.studentId} />}
        </Route>
        <Route path="/attendance/student">
          <StudentAttendanceReport />
        </Route>
        <Route path="/attendance/class/:className">
          {(params) => <ClassAttendanceReport className={decodeURIComponent(params.className)} />}
        </Route>
        <Route path="/attendance/class">
          <ClassAttendanceReport />
        </Route>
        <Route path="/">
          <Container className="py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h1 className="mb-0">Attendance Reports</h1>
              <div>
                <StudentSyncButton />
                <small><em>Students are synced at 8am daily.</em></small>
              </div>
            </div>
            <Row className="g-4">
              <Col md={6}>
                <Card className="h-100">
                  <Card.Body>
                    <Card.Title className="d-flex align-items-center mb-3">
                      Student Attendance Reports
                    </Card.Title>
                    <Card.Text className="mb-4">
                      View attendance history for individual students across all classes.
                    </Card.Text>
                    <StudentSelector />
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="h-100">
                  <Card.Body>
                    <Card.Title className="d-flex align-items-center mb-3">
                      Class Attendance Reports
                    </Card.Title>
                    <Card.Text className="mb-4">
                      View attendance records for all students in a specific class.
                    </Card.Text>
                    <ClassSelector />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="g-4 mt-2">
              <Col md={12}>
                <DuplicateStudentsCard />
              </Col>
            </Row>
          </Container>
        </Route>
      </Switch>
    </div>
  );
}

export default Reports;
